import React from "react";
import {
  Box, Card, Grid, Container, CardContent, Divider, CardHeader,
  TableBody, TableCell, TableContainer, TableHead, TableRow, Table, TableFooter
} from '@material-ui/core';
import moment from "moment";


export default class ComponentToPrint extends React.Component {

  render() {
    const loanHistoryList = this.props.loanHistoryList;
    const searchData = this.props.searchData;


    return (
      <div>
        <h3><center><u>Loan History Report</u></center></h3>
        <div>&nbsp;</div>
        <h4><center>Group :{searchData.groupName}</center></h4>
        <h4><center>Factory :{searchData.factoryName}</center></h4>
        <h4><center>Route :{searchData.routeName === undefined ? "All Routes" : searchData.routeName}</center></h4>
        <h4><center>Date :{moment(searchData.startDate).format("YYYY/MM/DD")} - {moment(searchData.endDate).format("YYYY/MM/DD")}</center></h4>
        <div>&nbsp;</div>
        <div>
          <Box minWidth={1050}>
            <TableContainer >
              <Table aria-label="caption table" size="small">
                <TableHead>
                  <TableRow>
                    <TableCell align={'left'} style={{ border: "1px #ccc solid" }}>Route Name</TableCell>
                    <TableCell align={'left'} style={{ border: "1px #ccc solid" }}>Reg No</TableCell>
                    <TableCell align={'left'} style={{ border: "1px #ccc solid" }}>Name</TableCell>
                    <TableCell align={'right'} style={{ border: "1px #ccc solid" }}>Loan Amount (Rs)</TableCell>
                    <TableCell align={'right'} style={{ border: "1px #ccc solid" }}>Installments</TableCell>
                    <TableCell align={'right'} style={{ border: "1px #ccc solid" }}>Interest Rate</TableCell>
                    <TableCell align={'left'} style={{ border: "1px #ccc solid" }}>Start Date</TableCell>
                    <TableCell align={'left'} style={{ border: "1px #ccc solid" }}>Status</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loanHistoryList.map((data, index) => (
                    <TableRow key={index}>
                      <TableCell align={'left'} component="th" scope="row" style={{ border: "1px #ccc solid" }}>
                        {data.routeName}
                      </TableCell>
                      <TableCell align={'left'} component="th" scope="row" style={{ border: "1px #ccc solid" }}>
                        {data.registrationNumber}
                      </TableCell>
                      <TableCell align={'left'} component="th" scope="row" style={{ border: "1px #ccc solid" }}>
                        {data.name}
                      </TableCell>
                      <TableCell align={'right'} component="th" scope="row" style={{ border: "1px #ccc solid" }}>
                      {data.principalAmount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </TableCell>
                      <TableCell align={'right'} component="th" scope="row" style={{ border: "1px #ccc solid" }}>
                        {data.numberOfInstalments}
                      </TableCell>
                      <TableCell align={'right'} component="th" scope="row" style={{ border: "1px #ccc solid" }}>
                        {data.annualRate}
                      </TableCell>
                      <TableCell align={'left'} component="th" scope="row" style={{ border: "1px #ccc solid" }}>
                        {data.loanIssuedDate.split('T')[0]}
                      </TableCell>
                      <TableCell align={'left'} component="th" scope="row" style={{ border: "1px #ccc solid" }}>
                        {data.isPaymentCompleated == true ? 'Completed' : 'Ongoing'}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </div>
      </div>
    );
  }
}
